export const calendars = state => state.calendars
export const events = state => state.events
